import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import {
  POST_NEW_PARTICIPANT,
  GET_PARTICIPANTS,
  GET_PARTICIPANT_DETAIL,
  DELETE_USER,
  POST_PARTICIPANT_DOC,
  POST_UPDATE_PARTICIPANT,
  GET_PARTICIPANT_DOC,
  UPDATE_PARTICIPANT_PIC,
  SHOW_HIDE_DOC,
  PARTICIPANT_CALENDER_DATA,
  SET_PART_STATE,
  DELETE_DOC,
  DELETE_DESCRIPTION,
  PARTICIPANTS_LOCATION_ASSIGNEES,
  PARTICIPANT_DETAILS_FOR_TASK,
  PARTICIPANT_STATUS_HISTORY,
  ADD_REMARK_ON_STATUS,
  GET_MYNDIS_GOAL,
} from "./actionTypes";
import {
  postNewParticipantSuccess,
  postNewParticipantFail,
  getParticipantsSuccess,
  getParticipantsFail,
  getParticipantDetailSuccess,
  getParticipantDetailFail,
  postDeleteParticipantSuccess,
  postDeleteParticipantFail,
  postPartDocSuccess,
  postPartDocFail,
  postUpdateParticipantSuccess,
  postUpdateParticipantFail,
  getPartDocSuccess,
  getPartDocFail,
  updateParticipantPicSuccess,
  updateParticipantPicFail,
  handleShowHideDocSuccess,
  handleShowHideDocFail,
  getPartCalDataFail,
  getPartCalDataSuccess,
  setPartstateSuccess,
  setPartstateFail,
  deletePartDocumentSuccess,
  deletePartDocumentFail,
  deletePartDescriptionSuccess,
  deletePartDescriptionFail,
  participantsLocationAssigneesSuccess,
  participantsLocationAssigneesFail,
  participantDetailsSuccess,
  participantDetailsFail,
  participantStatusHistorySuccess,
  participantStatusHistoryFail,
  addRemarkOnStatusSuccess,
  getNdisGoalSuccess,
  getNdisGoalFail,
} from "./actions";

import {
  postNewParticipant,
  getAllParticipants,
  getParticipantDetail,
  postDeleteUser,
  postParticipantDoc,
  updateParticipant,
  getPartDocouments,
  updatePartProPic,
  handleShowHideDocAPI,
  participantCalData,
  changePartState,
  onDeletingDocument,
  onDeletingPartDescription,
  onGettingParticipantAssignees,
  onGettingParticipantDetailsForTask,
  onGettingParticipantStatusLog,
  onAddingStatusRemark,
  onGetNdisGoal,
} from "../../helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

function* onDeleteDocument({ payload: data }) {
  try {
    const response = yield call(onDeletingDocument, data);
    if (response.status) {
      yield put(deletePartDocumentSuccess(response));
      showToast("success", "Participant", response.message);
    } else {
      yield put(deletePartDocumentFail(response));
      showToast("warning", "Participant", response.message);
    }
  } catch (error) {
    yield put(deletePartDocumentFail(error));
    showToast("error", "Participant", error);
  }
}

function* Set_Part_State({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(changePartState, data);
    yield call(responseHandler, "Participant", response, setPartstateSuccess, setPartstateFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(setPartstateFail(error));
    showToast("error", "Participant State", error);
  }
}

function* Handle_Show_Hide_doc({ payload: data }) {
  try {
    const response = yield call(handleShowHideDocAPI, data);
    yield put(handleShowHideDocSuccess(response));
    showToast("success", "Changes Saved...");
  } catch (error) {
    yield put(handleShowHideDocFail(error));
    showToast("error", "Participant", error);
  }
}

function* Update_Participant_Pro_Pic({ payload: data }) {
  try {
    const response = yield call(updatePartProPic, data);
    yield put(updateParticipantPicSuccess(response));
    showToast("success", "Participant", "Participant Picture Saved....");
  } catch (error) {
    yield put(updateParticipantPicFail(error));
    showToast("error", "Participant", error);
  }
}

function* Get_Part_Doc({ payload: data }) {
  try {
    const response = yield call(getPartDocouments, data);
    yield put(getPartDocSuccess(response));
  } catch (error) {
    yield put(getPartDocFail(error));
  }
}

function* Post_Part_Doc({ payload: data }) {
  try {
    const response = yield call(postParticipantDoc, data);
    yield put(postPartDocSuccess(response));
    showToast("success", "Participant", "New Participant Documents Saved.");
  } catch (error) {
    yield put(postPartDocFail(error));
    showToast("error", "Participant", error);
  }
}

function* Post_NewParticipant({ payload: user }) {
  try {
    const response = yield call(postNewParticipant, user);
    yield put(postNewParticipantSuccess(response));
    showToast("success", "Participant", "New Participant Details Saved.");
  } catch (error) {
    yield put(postNewParticipantFail(error));
    showToast("error", "Participant", error);
  }
}

function* onDeleteDescription({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingPartDescription, data);
    yield call(responseHandler, "Participant", response, deletePartDescriptionSuccess, deletePartDescriptionFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deletePartDescriptionFail(error));
    showToast("error", "Participant", error);
  }
}

function* Post_UpdateParticipant({ payload: user }) {
  try {
    const response = yield call(updateParticipant, { user });
    yield put(postUpdateParticipantSuccess(response));
    showToast("success", "Participant", response.message);
  } catch (error) {
    yield put(postUpdateParticipantFail(error));
    showToast("error", "Participant", error);
  }
}

// GET PARTICIPANTS LIST
function* Get_All_Participants({ payload: data }) {
  try {
    const response = yield call(getAllParticipants, data);
    yield put(getParticipantsSuccess(response));
  } catch (error) {
    yield put(getParticipantsFail(error));
  }
}

function* Get_ParticipantDetail({ projectId }) {
  try {
    const response = yield call(getParticipantDetail, projectId);
    yield put(getParticipantDetailSuccess(response));
  } catch (error) {
    yield put(getParticipantDetailFail(error));
  }
}

function* POST_DeleteUser({ payload: user }) {
  try {
    const response = yield call(postDeleteUser, user);
    yield put(postDeleteParticipantSuccess(response));
    showToast("success", "Participant", "Deleted Successfully");
  } catch (error) {
    yield put(postDeleteParticipantFail(error));
    showToast("error", "Participant", error);
  }
}

function* fetchPartCalData({ payload: data }) {
  try {
    const response = yield call(participantCalData, data);
    yield put(getPartCalDataSuccess(response));
  } catch (error) {
    yield put(getPartCalDataFail(error));
  }
}

function* onGetAssignees({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingParticipantAssignees, data);
    yield call(responseHandler, "Participant", response, participantsLocationAssigneesSuccess, participantsLocationAssigneesFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(participantsLocationAssigneesFail(error));
    showToast("error", "Participant", error);
  }
}

function* onGetParticipantStatusLog({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingParticipantStatusLog, data);
    yield call(responseHandler, "Participant", response, participantStatusHistorySuccess, participantStatusHistoryFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(participantStatusHistoryFail(error));
    showToast("error", "Participant", error);
  }
}

function* onAddStatusRemark({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingStatusRemark, data);
    yield call(responseHandler, "Participant", response, addRemarkOnStatusSuccess, addRemarkOnStatusSuccess, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addRemarkOnStatusSuccess(error));
    showToast("error", "Participant", error);
  }
}

function* onGetParticipantDetailForTask({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingParticipantDetailsForTask, data);
    yield call(
      responseHandler,
      "Participant",
      response,
      participantDetailsSuccess,
      participantDetailsFail,
      onSuccess,
      onError
      // false
    );
  } catch (error) {
    onError();
    yield put(participantDetailsFail(error));
    showToast("error", "Participant", error);
    console.log(error);
  }
}
// function* onGettingNdisGoal({payload:{data,onSuccess,onError}}){
//   try{
//     const response = yield call(onGetNdisGoal,data);
//     yield call(responseHandler,title,response,getNdisGoalSuccess,getNdisGoalFail,onSuccess,onError);
//   }catch(error){
//     onError();
//     yield put(getNdisGoalFail(error));
//     showToast("error",title,error);
//   }
// }
function* onGettingNdisGoal({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGetNdisGoal, data);
    yield call(responseHandler, "Getting Ndis Goal", response, getNdisGoalSuccess, getNdisGoalFail, onSuccess, onError);
  } catch (error) {
    console.log("Saga error:", error);
    onError();
    yield put(getNdisGoalFail(error));
    showToast("error", "Getting Ndis Goal", error);
  }
}

export function* watchPost_NewParticipant() {
  yield takeEvery(ADD_REMARK_ON_STATUS, onAddStatusRemark);
  yield takeEvery(PARTICIPANT_STATUS_HISTORY, onGetParticipantStatusLog);
  yield takeEvery(PARTICIPANT_DETAILS_FOR_TASK, onGetParticipantDetailForTask);
  yield takeEvery(PARTICIPANTS_LOCATION_ASSIGNEES, onGetAssignees);
  yield takeEvery(DELETE_DESCRIPTION, onDeleteDescription);
  yield takeEvery(POST_NEW_PARTICIPANT, Post_NewParticipant);
  yield takeEvery(GET_PARTICIPANTS, Get_All_Participants);
  yield takeEvery(GET_PARTICIPANT_DETAIL, Get_ParticipantDetail);
  yield takeEvery(DELETE_USER, POST_DeleteUser);
  yield takeEvery(POST_PARTICIPANT_DOC, Post_Part_Doc);
  yield takeEvery(POST_UPDATE_PARTICIPANT, Post_UpdateParticipant);
  yield takeEvery(GET_PARTICIPANT_DOC, Get_Part_Doc);
  yield takeEvery(UPDATE_PARTICIPANT_PIC, Update_Participant_Pro_Pic);
  yield takeEvery(SHOW_HIDE_DOC, Handle_Show_Hide_doc);
  yield takeEvery(PARTICIPANT_CALENDER_DATA, fetchPartCalData);
  yield takeEvery(SET_PART_STATE, Set_Part_State);
  yield takeEvery(DELETE_DOC, onDeleteDocument);
  yield takeEvery(GET_MYNDIS_GOAL, onGettingNdisGoal);
}

export default watchPost_NewParticipant;
